import { render, staticRenderFns } from "./PlatformNotificationsCard.vue?vue&type=template&id=18f5b283&"
import script from "./PlatformNotificationsCard.vue?vue&type=script&lang=js&"
export * from "./PlatformNotificationsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports